// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA

import { LogLevelType } from './enumerations/LogLevelType';
import appInsightsInstance from './containers/Singletons/AppInsights';

/* eslint-disable */
appInsightsInstance.log(LogLevelType.Info, 'service worker');
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
    ),
);

export function register(config) {
  appInsightsInstance.log(LogLevelType.Info, 'register-0');
  if ('serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    // const publicUrl = new URL("http://localhost:3000", window.location.href);
    // if (publicUrl.origin !== window.location.origin) {
    //   appInsightsInstance.log(LogLevelType.Info, 'register-3');
    //   // Our service worker won't work if PUBLIC_URL is on a different origin
    //   // from what our page is served on. This might happen if a CDN is used to
    //   // serve assets; see https://github.com/facebook/create-react-app/issues/2374
    //   return;
    // }
    appInsightsInstance.log(LogLevelType.Info, 'register-1');
    window.addEventListener('load', () => {
      appInsightsInstance.log(LogLevelType.Info, 'register-2');
      const swFileName = 'sw.js';
      const swUrl = `/${swFileName}`;
      registerValidSW(swUrl, config);
      if (isLocalhost) {
        appInsightsInstance.log(LogLevelType.Info, 'register-3');
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config);
        appInsightsInstance.log(LogLevelType.Info, 'register-4');
        // Add some additional logging to localhost, pointing developers to the
        // service worker/PWA documentation.
        navigator.serviceWorker.ready.then(() => {
          appInsightsInstance.log(
            LogLevelType.Info,
            'This web app is being served cache-first by a service ' +
              'worker. To learn more, visit https://bit.ly/CRA-PWA',
          );
        });
      } else {
        appInsightsInstance.log(LogLevelType.Info, 'register-5');
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  appInsightsInstance.log(LogLevelType.Info, 'registerValidSW-0', swUrl);
  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      appInsightsInstance.log(LogLevelType.Info, 'registerValidSW-1');
      registration.onupdatefound = () => {
        appInsightsInstance.log(LogLevelType.Info, 'registerValidSW-2');
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          appInsightsInstance.log(LogLevelType.Info, 'registerValidSW-3');
          return;
        }
        appInsightsInstance.log(LogLevelType.Info, 'registerValidSW-4');
        installingWorker.onstatechange = () => {
          appInsightsInstance.log(LogLevelType.Info, 'registerValidSW-5');
          if (installingWorker.state === 'installed') {
            appInsightsInstance.log(LogLevelType.Info, 'registerValidSW-6');
            if (navigator.serviceWorker.controller) {
              // At this point, the updated precached content has been fetched,
              // but the previous service worker will still serve the older
              // content until all client tabs are closed.
              appInsightsInstance.log(
                LogLevelType.Info,
                'New content is available and will be used when all ' +
                  'tabs for this page are closed. See https://bit.ly/CRA-PWA.',
              );

              appInsightsInstance.log(LogLevelType.Info, 'registerValidSW-7');
              // Execute callback
              if (config && config.onUpdate) {
                appInsightsInstance.log(LogLevelType.Info, 'registerValidSW-8');
                config.onUpdate(registration);
              }
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              appInsightsInstance.log(
                LogLevelType.Info,
                'Content is cached for offline use.',
              );

              // Execute callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch(error => {
      appInsightsInstance.log(
        LogLevelType.Error,
        'Error during service worker registration:',
        error,
      );
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  appInsightsInstance.log(LogLevelType.Info, 'checkValidServiceWorker-0');
  fetch(swUrl)
    .then(response => {
      // Ensure service worker exists, and that we really are getting a JS file.
      appInsightsInstance.log(LogLevelType.Info, 'checkValidServiceWorker-1');
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        appInsightsInstance.log(LogLevelType.Info, 'checkValidServiceWorker-2');
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      appInsightsInstance.log(
        LogLevelType.Error,
        'No internet connection found. App is running in offline mode.',
      );
    });
}

export function unregister() {
  appInsightsInstance.log(LogLevelType.Info, 'unregister-0');
  if ('serviceWorker' in navigator) {
    appInsightsInstance.log(LogLevelType.Info, 'unregister-1');
    navigator.serviceWorker.ready.then(registration => {
      appInsightsInstance.log(LogLevelType.Info, 'unregister-2');
      registration.unregister();
    });
  }
}
